<div class="invoice-wrapper" id="invoice-print-area">
  <div class="invoice-top-bar">
    <span class="date">2/19/26, 7:10 PM</span>
    <span class="system-name">CMS Global Invoice System</span>
    <span class="page">1</span>
  </div>

  <div class="invoice-content">
    <h2 class="branch-name">TestBranch</h2>
    <h3 class="receipt-title">إيصال إستلام نقدية</h3>
    <p class="sub-title">"إشتراك"</p>

    <div class="info-section">
      <div class="info-row">
        <span class="label">كود العضوية :</span>
        <span class="value">{{ invoice.membershipCode }}</span>
      </div>
      <div class="info-row">
        <span class="label">كود الدخول :</span>
        <span class="value">{{ invoice.accessCode }}</span>
      </div>
      <div class="info-row">
        <span class="label">اسم المُشترك :</span>
        <span class="value">{{ invoice.customerName }}</span>
      </div>
      <div class="info-row">
        <span class="label">تليفون المُشترك :</span>
        <span class="value">{{ invoice.phone }}</span>
      </div>
      <div class="info-row">
        <span class="label">العضوية :</span>
        <span class="value">{{ invoice.plan }}</span>
      </div>
      <div class="info-row">
        <span class="label">موظف المبيعات :</span>
        <span class="value">{{ invoice.salesEmployee }}</span>
      </div>
      <div class="info-row">
        <span class="label">المُدرب الخاص :</span>
        <span class="value">{{ invoice.trainer }}</span>
      </div>
      <div class="info-row">
        <span class="label">تاريخ الدفع :</span>
        <span class="value">{{ invoice.paymentDate }}</span>
      </div>
      <div class="info-row">
        <span class="label">تاريخ بداية الإشتراك :</span>
        <span class="value">{{ invoice.startDate }}</span>
      </div>
      <div class="info-row">
        <span class="label">تاريخ إنتهاء الإشتراك :</span>
        <span class="value">{{ invoice.endDate }}</span>
      </div>

      <div class="divider"></div>

      <div class="info-row">
        <span class="label">إجمالي المطلوب :</span>
        <span class="value">{{ invoice.totalRequired }}</span>
      </div>
      <div class="info-row">
        <span class="label">المدفوع نقداً :</span>
        <span class="value">{{ invoice.paidCash }}</span>
      </div>
      <div class="info-row">
        <span class="label">المدفوع بالبطاقة :</span>
        <span class="value">{{ invoice.paidCard }}</span>
      </div>
      <div class="info-row">
        <span class="label">المدفوع تحويل فوري :</span>
        <span class="value">{{ invoice.paidTransfer }}</span>
      </div>
      <div class="info-row">
        <span class="label">إجمالي المدفوع :</span>
        <span class="value">{{ invoice.totalPaid }}</span>
      </div>
      <div class="info-row">
        <span class="label">المبلغ المُتبقي :</span>
        <span class="value">{{ invoice.remaining }}</span>
      </div>
      <div class="info-row">
        <span class="label">الخصم المُطبق :</span>
        <span class="value">{{ invoice.discount }} %</span>
      </div>
    </div>

    <div class="notes-section" *ngIf="invoice.notes">
      <p class="section-title">ملاحظات :</p>
      <p>{{ invoice.notes }}</p>
    </div>

    <div class="benefits-section">
      <p class="section-title">المزايا :</p>
      <p *ngFor="let benefit of invoice.benefits" class="benefit-item">
        {{ benefit.name }} {{ benefit.count }}
      </p>
    </div>
  </div>

  <div class="invoice-footer">
    <span class="url"
      >https://cms.h2ogym.net/transactions/show_invoice/1311362</span
    >
    <span class="page-count">1/2</span>
  </div>
</div>
